import React, { useState } from "react";
import { api } from "@/lib/api";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, Envelope } from "@phosphor-icons/react";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("seva_admin_token", data.access_token);
      localStorage.setItem("seva_admin_name", data.name || "");
      toast.success(`Welcome, ${data.name || "Admin"}`);
      nav("/admin");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#FBF9F6] p-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <div className="w-14 h-14 rounded-full bg-[#4FAC39] text-white grid place-items-center font-display font-bold text-xl mx-auto">
            S
          </div>
          <h1 className="font-display font-bold text-3xl mt-4">SEVA Admin</h1>
          <p className="text-[#56624F] text-sm mt-1">Manage campaigns, donors & settings</p>
        </div>
        <form onSubmit={submit} className="seva-card space-y-4" data-testid="admin-login-form">
          <label className="block">
            <div className="text-sm font-semibold mb-1.5 flex items-center gap-2"><Envelope size={16} /> Email</div>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="admin-login-email"
              className="w-full px-4 py-3 rounded-xl border border-[#DCE5D4] focus:border-[#4FAC39] outline-none bg-white"
            />
          </label>
          <label className="block">
            <div className="text-sm font-semibold mb-1.5 flex items-center gap-2"><Lock size={16} /> Password</div>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="admin-login-password"
              className="w-full px-4 py-3 rounded-xl border border-[#DCE5D4] focus:border-[#4FAC39] outline-none bg-white"
            />
          </label>
          <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="admin-login-submit">
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
